<template>
  <rhcn-drawer :title="titleText" @on-close="onClose">
    <div v-loading="dataLoading" class="contact-form">
      <el-form class="margin-bottom-40">
        <el-form-item :label="$t('message.contact.transferTo')" :prop="formData.bankCountry">
          <el-select v-model="formData.bankCountry" filterable @change="handleChangeCountry">
            <template v-for="(country, index) in countryList">
              <el-option :label="country.description" :value="country.value" :key="index"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="contact-title-box margin-bottom-15" :class="{ open: showContactInfo }"
        @click="showContactInfo = !showContactInfo">
        <span>{{ $t('message.transfer.payeeInformation') }}</span>
        <span class="el-icon-caret-bottom icon-caret"></span>
      </div>
      <div v-show="showContactInfo" class="payee-info-box">
        <validation-component ref="contactFormRef" :validation-condition="contactCondition">
        </validation-component>
      </div>
      <!-- && !this.contactId -->
      <!-- @change="selectedMethodChange" -->
      <div class="methodType" v-if="transferMethodList && transferMethodList.length && !this.contactId">
        <!-- <el-radio-group v-model="selectedMethod">
          <el-radio-button :label="$t(item.value)" :key="item.value" v-for="item in transferMethodListOptions"
            v-show="transferMethodList.includes(item.value)">{{
              $t(item.label) }} </el-radio-button>
        </el-radio-group> -->
        <p class="payout-method-title margin-bottom-20">
          {{ $t('message.transfer.howToPayoutMethod') }}</p>
        <div class="payout-method-list margin-bottom-20">
          <div v-if="transferMethodList.includes('SWIFT')" class="payout-method-item"
            :class="{ checked: selectedMethod === 'SWIFT' }" @click="handlePayoutMethod('SWIFT')">
            {{ $t('message.contact.swiftTitle') }}</div>
          <div v-if="transferMethodList.includes('BANK_TRANSFER')" class="payout-method-item"
            :class="{ checked: selectedMethod === 'BANK_TRANSFER' }" @click="handlePayoutMethod('BANK_TRANSFER')">
            {{ $t('message.transfer.bankTransfer') }}</div>
          <div v-if="transferMethodList.includes('E_WALLET')" class="payout-method-item"
            :class="{ checked: selectedMethod === 'E_WALLET' }" @click="handlePayoutMethod('E_WALLET')">
            {{ $t('message.transfer.eWallet') }}</div>
          <div v-if="transferMethodList.includes('CASH_PICKUP')" class="payout-method-item"
            :class="{ checked: selectedMethod === 'CASH_PICKUP' }" @click="handlePayoutMethod('CASH_PICKUP')">
            {{ $t('message.transfer.cashPickup') }}</div>
        </div>
      </div>
      <div v-show="transferMethodList.includes('BANK_TRANSFER') && selectedMethod === 'BANK_TRANSFER'">
        <!-- <div class="contact-title-box margin-top-25 margin-bottom-15" :class="{ open: showBankInfo }"
          @click="showBankInfo = !showBankInfo">
          <span>{{ $t('message.contact.accountBank') }}（{{ $t('message.common.optional') }}）</span>
          <span class="el-icon-caret-bottom icon-caret"></span>
        </div> -->
        <div v-show="showBankInfo" class="bank-info-box">
          <validation-component ref="bankFormRef" :validation-condition="bankCondition">
          </validation-component>
        </div>
      </div>
      <!-- swift -->
      <div v-show="transferMethodList.includes('SWIFT') && selectedMethod === 'SWIFT'">
        <!-- <div class="contact-title-box margin-top-25 margin-bottom-15" :class="{ open: showSwiftInfo }"
          @click="showSwiftInfo = !showSwiftInfo">
          <span>{{ $t('message.contact.swiftTitle') }}（{{ $t('message.common.optional') }}）</span>
          <span class="el-icon-caret-bottom icon-caret"></span>
        </div> -->
        <div v-show="showSwiftInfo" class="bank-info-box">
          <validation-component ref="swiftFormRef" :validation-condition="swiftCondition">
          </validation-component>
        </div>
      </div>
      <div v-show="transferMethodList.includes('E_WALLET') && selectedMethod === 'E_WALLET'">
        <!-- <div class="contact-title-box margin-top-25 margin-bottom-15" :class="{ open: showWalletInfo }"
          @click="showWalletInfo = !showWalletInfo">
          <span>{{ $t('message.contact.accountWallet') }}（{{ $t('message.common.optional') }}）</span>
          <span class="el-icon-caret-bottom icon-caret"></span>
        </div> -->
        <div v-show="showWalletInfo" class="wallet-info-box">
          <validation-component ref="walletFormRef" :validation-condition="walletCondition">
          </validation-component>
        </div>
      </div>
      <div v-show="transferMethodList.includes('CASH_PICKUP') && selectedMethod === 'CASH_PICKUP'">
        <!-- <div class="contact-title-box margin-top-25 margin-bottom-15" :class="{ open: showCashInfo }"
          @click="showCashInfo = !showCashInfo">
          <span>{{ $t('message.contact.accountCash') }}（{{ $t('message.common.optional') }}）</span>
          <span class="el-icon-caret-bottom icon-caret"></span>
        </div> -->
        <div v-show="showCashInfo" class="cash-info-box">
          <validation-component ref="cashFormRef" :validation-condition="cashCondition">
          </validation-component>
        </div>
      </div>
      <div class="margin-top-40"></div>
      <!-- <div v-if="fromTransfer">
        <el-checkbox v-model="isSaveContact">
          <span class="btn-save-contact">{{$t('message.contact.saveContact')}}</span>
        </el-checkbox>
      </div> -->
      <div class="margin-top-18 margin-bottom-30 bottom-box">
        <el-button :loading="requesting" :disabled="dataLoading || btnDisabled" style="width:100%;" type="primary"
          @click="onSubmit">{{ fromTransfer ? $t('message.common.next') : $t('message.common.confirm') }}</el-button>
        <p v-if="fromTransfer" class="btn-previous margin-top-10" @click="onClose">{{ $t('message.common.previous') }}
        </p>
      </div>
    </div>
  </rhcn-drawer>
</template>
<script>
import { mapGetters } from 'vuex';

import { queryCountryCity } from '@/api/common/index';
import RhcnDrawer from '@/components/drawer/index.vue';
import { ShowErrorMessage, ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import { REQUIRED, PHONE_NUMBER, ENGLISH_NAME, AllNumber, EN_NUMBER_SPACE, EMAIL } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { arr2obj, shallowClones } from '@/utils/tools/utils';
import AccountInfo from '@/views/account/information/api/account-info';
import {
  getCountryGroupListByName, getPayeeInfo,
  postUpdatePayeeVerify, postAddPayeeVerify,
  postValidatePayee, queryPickUpBankNameByCountry,
  queryPickUpBankBranchInfo, queryPayoutExchangeConfig,
  queryWalletTypeByCountry, queryBankInfoBySwiftAndCountry,
  queryPayeeFields,
} from '@/views/transfer/api/contact';
import {
  PAYEE_FIELDS, TXN_FIELDS,
} from '@/views/transfer/api/fields';
import {
  ENTITY_TYPE_OPTIONS, ACCOUNT_TYPE_OPTIONS,
  COUNTRY_PHONE_CODE_MAP,
} from '@/views/transfer/api/options';
import TransferService from '@/views/transfer/api/transfer';

export default {
  components: { RhcnDrawer, ValidationComponent },
  data() {
    return {
      // 添加这两个新属性
      isQueryingPayoutMethods: false, // 查询状态标志
      pendingQueryParams: null, // 待处理的查询参数
      lastValidMethodList: [], // 保存最后一个有效的方法列表
      titleText: '',
      dataLoading: false,
      btnDisabled: false,
      contactId: '',
      showContactInfo: true,
      showBankInfo: false,
      showSwiftInfo: false,
      showWalletInfo: false,
      showCashInfo: false,
      formData: {
        bankCountry: '',
        accountBelong: '1', // 默认他人
      },
      contactCondition: [
        {
          key: 'payoutCurrency',
          name: 'message.contact.accountCurrency',
          type: 'select',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          options: [],
          option: {
            label: 'value',
            value: 'value',
          },
          // multiple: true,
          changeValue: async () => {
            await this.queryPayoutRouteList();
            this.onChangeValue();
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'entityType',
          name: 'message.contact.beneficiaryType',
          type: 'select',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          options: ENTITY_TYPE_OPTIONS,
          isInternationalization: true,
          changeValue: async () => {
            await this.queryPayoutRouteList();
            this.$refs.contactFormRef.setItemValue('vatNumber', '');
            this.onChangeValue();
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'payee',
          name: 'message.contact.nickname',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          tipList: [{
            key: '',
            value: this.$t('message.contact.payeeTips'),
          }],
          validator: this.validatePayee,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          type: 'continuity_select_input',
          key: 'name',
          // isHide: true,
          subCondition: [
            {
              key: 'firstName',
              name: 'message.contact.firstName',
              type: 'input',
              defValue: '',
              isShowStar: true,
              rule: [],
              maxLength: 29,
              isHide: true,
              validator: this.validateFirstName,
              changeValue: (value) => {
                const v = value.replace(/[^a-zA-Z\s]/g, '');
                this.$refs.contactFormRef.setItemValue('firstName', v);
                this.checkFieldHasChanged();
              },
            },
            {
              key: 'lastName',
              name: 'message.contact.lastName',
              type: 'input',
              defValue: '',
              isShowStar: true,
              rule: [],
              maxLength: 29,
              isHide: true,
              validator: this.validateLastName,
              changeValue: (value) => {
                const v = value.replace(/[^a-zA-Z\s]/g, '');
                this.$refs.contactFormRef.setItemValue('lastName', v);
                this.checkFieldHasChanged();
              },
            },
          ],
        },
        {
          key: 'companyName',
          name: 'message.contact.companyName',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          maxLength: 29,
          validator: this.validateCompanyName,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'birthDate',
          name: 'message.contact.birthDate',
          type: 'date_time',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          dateType: 'date',
          dateFormat: 'yyyy-MM-dd',
          dateValueFormat: 'yyyy-MM-dd',
          pickerOptions: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
          },
          validator: this.validateBirthDate,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'email',
          name: 'message.user.email',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          maxLength: 64,
          isHide: true,
          validator: this.validateEmail,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'state',
          name: 'message.contact.state',
          type: 'select',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          options: [],
          validator: this.validateState,
          changeValue: () => {
            this.$refs.contactFormRef.setItemValue('city', '');
            this.onChangeValue();
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'city',
          name: 'message.contact.city',
          type: 'select',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          options: [],
          validator: this.validateCity,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'phone',
          name: 'message.contact.payeePhone',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          maxLength: 15,
          prepend: '',
          validator: this.validatePhone,
          changeValue: (value) => {
            const v = value.match(/^\d*(\d{0,10})/g)[0];
            this.$refs.contactFormRef.setItemValue('phone', v);
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'address1',
          name: 'message.contact.address',
          type: 'input',
          placeholder: 'message.contact.addressPlaceholder1',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          maxLength: 199,
          validator: this.validateAddress1,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'address2',
          name: '',
          type: 'input',
          placeholder: 'message.contact.addressPlaceholder2',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          maxLength: 199,
          validator: this.validateAddress2,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'address3',
          name: '',
          type: 'input',
          placeholder: 'message.contact.addressPlaceholder3',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          maxLength: 199,
          validator: this.validateAddress3,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'zipCode',
          name: 'message.contact.zipCode',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          maxLength: 7,
          validator: this.validateZipCode,
          changeValue: (value) => {
            const v = value.replace(/[^a-zA-Z0-9]/g, '');
            this.$refs.contactFormRef.setItemValue('zipCode', v ? v.toUpperCase() : v);
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'vatNumber',
          name: 'CPF',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          maxLength: 11,
          isHide: true,
          validator: this.validateVatNumber,
          changeValue: (value) => {
            // const v = value.replace(/[^0-9]/g, '');
            // this.$refs.contactFormRef.setItemValue('vatNumber', v);
            this.checkFieldHasChanged();
          },
        },
      ],
      bankCondition: [
        {
          key: 'swiftCode',
          name: 'message.contact.swiftCodeInputTitle',
          type: 'select',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          placeholder: 'message.contact.swiftCodeInputTips',
          remote: true,
          noDataText: 'message.contact.atLeast3SwiftCodeTips',
          filterMethod: async (value) => {
            if (!this.formData.bankCountry) {
              return;
            }
            const bankForm = this.$refs.bankFormRef;
            bankForm.setItemLoading('swiftCode', true);
            if (value && value.length > 2) {
              bankForm.setItemNoDataText('swiftCode', 'message.common.noDataText');
              this.swiftCodeList = await queryBankInfoBySwiftAndCountry({ country: this.formData.bankCountry, swiftCode: value });
            } else {
              bankForm.setItemNoDataText('swiftCode', 'message.contact.atLeast3SwiftCodeTips');
              this.swiftCodeList = [];
            }
            bankForm.setItemLoading('swiftCode', false);
            bankForm.setValidationSelectOptions('swiftCode', this.swiftCodeList);
          },
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'accountType',
          name: 'message.contact.acType',
          type: 'select',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          options: [],
          // validator: this.validateAccountType,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'bankHolderName',
          name: 'message.contact.accountName',
          type: 'input',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          isHide: true,
          validator: this.validateBankHolderName,
          tipList: [{
            value: this.$t('message.contact.bankHolderNameTip'),
          }],
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'cardNumber',
          name: 'message.contact.accountNumber',
          type: 'input',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          changeValue: (value) => {
            const v = value.replace(/\s+/g, '');
            this.$refs.bankFormRef.setItemValue('cardNumber', v.toUpperCase());
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'sortCode',
          name: 'message.contact.bankCode',
          type: 'input',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          isHide: true,
          validator: this.validateSortCode,
          tipList: [{
            value: this.$t('message.contact.bankCodeTips'),
          }],
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'branchCode',
          name: 'message.contact.branchCode',
          type: 'input',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          isHide: true,
          validator: this.validateBranchCode,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
      ],
      swiftCondition: [
        {
          key: 'swiftCode',
          name: 'message.contact.swiftCodeInputTitle',
          type: 'select',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          placeholder: 'message.contact.swiftCodeInputTips',
          remote: true,
          noDataText: 'message.contact.atLeast3SwiftCodeTips',
          filterMethod: async (value) => {
            if (!this.formData.bankCountry) {
              return;
            }
            const swiftForm = this.$refs.swiftFormRef;
            swiftForm.setItemLoading('swiftCode', true);
            if (value && value.length > 2) {
              swiftForm.setItemNoDataText('swiftCode', 'message.common.noDataText');
              this.swiftCodeList = await queryBankInfoBySwiftAndCountry({ country: this.formData.bankCountry, swiftCode: value });
            } else {
              swiftForm.setItemNoDataText('swiftCode', 'message.contact.atLeast3SwiftCodeTips');
              this.swiftCodeList = [];
            }
            swiftForm.setItemLoading('swiftCode', false);
            swiftForm.setValidationSelectOptions('swiftCode', this.swiftCodeList);
          },
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'accountType',
          name: 'message.contact.acType',
          type: 'select',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          options: [],
          // validator: this.validateAccountType,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'bankHolderName',
          name: 'message.contact.accountName',
          type: 'input',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          isHide: true,
          validator: this.validateBankHolderName,
          tipList: [{
            value: this.$t('message.contact.bankHolderNameTip'),
          }],
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'cardNumber',
          name: 'message.contact.accountNumber',
          type: 'input',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          changeValue: (value) => {
            const v = value.replace(/\s+/g, '');
            this.$refs.swiftFormRef.setItemValue('cardNumber', v.toUpperCase());
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'sortCode',
          name: 'message.contact.bankCode',
          type: 'input',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          isHide: true,
          validator: this.validateSortCode,
          tipList: [{
            value: this.$t('message.contact.bankCodeTips'),
          }],
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'branchCode',
          name: 'message.contact.branchCode',
          type: 'input',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          isHide: true,
          validator: this.validateBranchCode,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
      ],
      walletCondition: [
        {
          key: 'walletType',
          name: 'message.contact.walletType',
          type: 'select',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          changeValue: (value) => {
            if (value) {
              const walletTypeInfo = this.walletTypeList.filter(item => item.walletType === value)[0];
              const bankCountry = this.formData.bankCountry;
              if (bankCountry) {
                this.$refs.walletFormRef.getValidationItem('walletPhone').prepend = walletTypeInfo && walletTypeInfo.textType !== 'TEXT' && bankCountry ? COUNTRY_PHONE_CODE_MAP[bankCountry] : '';
              }
            }
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'walletPhone',
          name: 'message.contact.walletPhone',
          type: 'input',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          // maxLength: 11,
          prepend: '',
          // validator: this.validateWalletPhone,
          changeValue: (value) => {
            let v = value.match(/^\d*(\d{0,10})/g)[0];
            const walletData = this.$refs.walletFormRef.getFormJson();
            const walletType = walletData.walletType;
            if (walletType) {
              const walletTypeInfo = this.walletTypeList.filter(item => item.walletType === walletType)[0];
              if (walletTypeInfo && walletTypeInfo.textType === 'TEXT') {
                v = value;
              }
            }
            this.$refs.walletFormRef.setItemValue('walletPhone', v);
            this.checkFieldHasChanged();
          },
        },
      ],
      cashCondition: [
        {
          key: 'pickUpBankName',
          name: 'message.contact.pickUpBank',
          type: 'select',
          defValue: '',
          options: [],
          rule: [REQUIRED],
          isShowStar: true,
          changeValue: async (value) => {
            this.bankBranchInfoList = [];
            this.$refs.cashFormRef.setItemValue('pickUpBankBranchName', '');
            if (!value) {
              this.$refs.cashFormRef.setValidationSelectOptions('pickUpBankBranchName', []);
              return;
            }
            // 获取分支机构
            this.$refs.cashFormRef.setItemLoading('pickUpBankBranchName', true);
            try {
              const res = await queryPickUpBankBranchInfo({ institutionName: value });
              this.bankBranchInfoList = res;
              const bankBranchList = [{
                value: 'title',
                label: this.$t('message.contact.bankBranchName'),
                disabled: true,
                type: 'title',
              }];
              const bankBranchMap = {};
              res.forEach(item => {
                const branchName = item.branchName;
                const branchAddress = item.branchAddress;
                if (!bankBranchMap[branchName]) {
                  bankBranchMap[branchName] = {
                    value: branchName,
                    label: branchName,
                    children: [],
                  };
                }
                if (branchAddress) {
                  bankBranchMap[branchName].children.push({
                    value: branchAddress,
                    label: branchAddress,
                  });
                }
              });

              Object.keys(bankBranchMap).forEach(k => {
                const item = bankBranchMap[k];
                const obj = {
                  value: item.value,
                  label: item.label,
                };
                if (item.children && item.children.length > 0) {
                  obj.children = item.children;
                  obj.children.unshift({
                    value: 'subtitle',
                    label: this.$t('message.contact.bankBranchAddress'),
                    disabled: true,
                    type: 'title',
                  });
                }
                bankBranchList.push(obj);
              });
              this.$refs.cashFormRef.setValidationSelectOptions('pickUpBankBranchName', bankBranchList);
            } catch (err) {
              //
              console.log(err);
            }
            this.$refs.cashFormRef.setItemLoading('pickUpBankBranchName', false);
            this.checkFieldHasChanged();
          },
        },
        {
          key: 'pickUpBankBranchName',
          name: 'message.contact.branchName',
          type: 'cascader',
          defValue: '',
          options: [],
          rule: [REQUIRED],
          isShowStar: true,
          changeValue: () => {
            this.checkFieldHasChanged();
          },
        },
      ],
      requesting: false,
      euCountryMap: {},
      registration: '', // 商户注册地
      countryList: [],
      fromTransfer: false,
      isSaveContact: false,
      swiftCodeList: [],
      transferMethodList: [],
      countryInfo: [],
      bankBranchInfoList: [],
      payeeFieldList: [],
      txnFieldList: [],
      walletTypeList: [],
      // /**
      // * 支付方式，0: LOCAL; 1: SWIFT; 2 银行转账; 3 钱包; 4 现金支取
      // */
      transferMethodListOptions: [
        {
          label: 'message.contact.accountBank',
          value: 'BANK_TRANSFER',
          code: '2',
        },
        {
          label: 'message.contact.swiftTitle',
          value: 'SWIFT',
          code: '1',
        },
        {
          label: 'message.contact.accountWallet',
          value: 'E_WALLET',
          code: '3',

        },
        {
          label: 'message.contact.accountCash',
          value: 'CASH_PICKUP',
          code: '4',

        },
      ],
      selectedMethod: '',
    };
  },
  mounted() {
    const { contactId, from } = this.$route.query;
    if (from === 'transfer') {
      this.fromTransfer = true;
    }
    this.contactId = contactId;
    if (this.contactId) {
      this.titleText = this.$t('message.contact.editContact');
    } else {
      this.titleText = this.$t('message.contact.addContact');
    }
    this._isQueryingMethods = false; // 初始化查询锁标志
    this.initData();
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    businessType() {
      return this.$route.query.businessType || '';
    },
  },
  methods: {
    selectedMethodChange(selectedMethod) {
      switch (selectedMethod) {
        case 'BANK_TRANSFER':
          this.showBankInfo = true;
          break;
        case 'SWIFT':
          this.showSwiftInfo = true;
          break;
        case 'E_WALLET':
          this.showWalletInfo = true;
          break;
        case 'CASH_PICKUP':
          this.showCashInfo = true;
          break;

        default:
          break;
      }
    },
    async initData() {
      this.dataLoading = true;
      const accountInfo = await AccountInfo.getAccountInfo();
      this.registration = accountInfo.country;
      // 获取收款方国家、收款行国家
      const res = await getCountryGroupListByName({ countryGroupName: 'payment-payout' });
      this.countryList = (res.countryGroupInfos || []).map((item) => ({
        description: item.description,
        value: item.value,
      }));
      // 获取欧洲国家
      const res1 = await getCountryGroupListByName({ countryGroupName: 'payment-EU' });
      const euCountryList = (res1.countryGroupInfos || []).map((item) => ({
        description: item.description,
        value: item.value,
      }));
      this.euCountryMap = arr2obj(euCountryList, { key: 'value' });

      // 获取联系人详情
      if (this.contactId) {
        const res = await getPayeeInfo({ cardInfoId: this.contactId });
        const data = {};
        [
          'accountBelong', 'entityType', 'payoutCurrency', 'bankCountry',
          'payee', 'payeeAddress', 'bankAccount', 'cardNumber', 'sortCode',
          'swiftCode', 'idNumber', 'bankName', 'bankAddress',
          'phone', 'firstName', 'lastName', 'vatNumber', 'address', 'zipCode', 'companyName',
          'walletType', 'walletPhone', 'pickUpBankName', 'pickUpBankBranchId', 'accountType', 'branchCode',
          'state', 'city', 'address1', 'address2', 'address3', 'birthDate', 'bankHolderName', 'email',
        ].forEach(k => {
          if (res[k]) {
            // if (k === 'payoutCurrency') {
            //   data[k] = res[k].split(',');
            // } else {
            //   data[k] = res[k];
            // }
            data[k] = res[k];
          }
        });
        console.log(data, '222222');

        this.$refs.contactFormRef.assignmentFormValue(data);
        this.$refs.bankFormRef.assignmentFormValue(data);
        this.$refs.swiftFormRef.assignmentFormValue(data);
        this.$refs.walletFormRef.assignmentFormValue(data);
        this.$refs.cashFormRef.assignmentFormValue(data);

        if (data.swiftCode) {
          this.swiftCodeList = await queryBankInfoBySwiftAndCountry({ country: data.bankCountry, swiftCode: data.swiftCode });
          this.$refs.bankFormRef.setValidationSelectOptions('swiftCode', this.swiftCodeList);
          this.$refs.swiftFormRef.setValidationSelectOptions('swiftCode', this.swiftCodeList);
        }

        this.formData.accountBelong = data.accountBelong;
        this.formData.bankCountry = data.bankCountry;

        let accountTypeOptions = ACCOUNT_TYPE_OPTIONS;
        if (data.bankCountry !== 'JP') {
          accountTypeOptions = ACCOUNT_TYPE_OPTIONS.filter(item => item.value !== 'ordinary');
        }
        this.$refs.bankFormRef.setValidationSelectOptions('accountType', shallowClones(accountTypeOptions));
        this.$refs.swiftFormRef.setValidationSelectOptions('accountType', shallowClones(accountTypeOptions));

        await this.fetchCountryInfo();

        this.onChangeValue();
        await this.fetchPayoutConfig(data.bankCountry);
        if (data.pickUpBankBranchId) {
          for (let i = 0; i < this.bankBranchInfoList.length; i++) {
            const bankBranch = this.bankBranchInfoList[i];
            if (bankBranch.branchId === data.pickUpBankBranchId) {
              this.$refs.cashFormRef.setItemValue('pickUpBankBranchName', bankBranch.branchName + (bankBranch.branchAddress ? `***${bankBranch.branchAddress}` : ''));
              break;
            }
          }
        }
        this.oldInfo = { ...res };
        await this.queryPayoutRouteList();
        debugger;
        this.onChangeValue();
        this.btnDisabled = true;
      }
      this.dataLoading = false;
    },
    async queryPayoutRouteList() {
      console.log('触发了吗guan2');
      // 保存当前的转账方式列表
      const currentMethodList = [...this.transferMethodList];

      // 判断
      const contactData = this.$refs.contactFormRef.getFormJson();
      const bankCountry = this.formData.bankCountry;
      const { entityType, payoutCurrency } = contactData;

      // 如果条件不满足，直接返回，不清空现有列表
      if (!bankCountry || !entityType || !payoutCurrency) {
        return;
      }
      // 添加锁，防止并发执行
      if (this._isQueryingMethods) {
        return;// 如果已有查询在执行，直接返回
      }

      this._isQueryingMethods = true;
      this.dataLoading = true;
      let payeeFields = '';
      let txnFields = '';
      try {
        const res = await TransferService.queryPayoutRouteMethod({
          paymentToCountry: bankCountry,
          accountType: entityType,
          payeeCurrency: payoutCurrency,
        });
        // 只有当结果有效时才更新列表
        if (res && Array.isArray(res) && res.length > 0) {
          this.transferMethodList = res;
        } else if (currentMethodList.length > 0) {
          // 如果新结果为空但之前有值，则保留之前的值
          this.transferMethodList = currentMethodList;
        }
        if (this.transferMethodList.length === 0) {
          ShowErrorMessage(this.$t('message.transfer.noTransferMethodTips'));
        } else {
          // 获取字段配置信息
          const fieldsRes = await queryPayeeFields({
            paymentToCountry: bankCountry,
            accountType: entityType,
            payeeCurrency: payoutCurrency,
          });
          if (fieldsRes && fieldsRes.payeeFields) {
            payeeFields = fieldsRes.payeeFields;
            txnFields = fieldsRes.txnFields;
            if (this.contactId) {
              const paymentMethod = this.oldInfo.paymentMethod;
              if (paymentMethod) {
                this.selectedMethod = this.transferMethodListOptions.find(item => item.code === paymentMethod)?.value;
              } else {
                if (!fieldsRes.paymentMethod && this.transferMethodList && this.transferMethodList.length) {
                  this.selectedMethod = this.transferMethodList[0];
                } else {
                  this.selectedMethod = fieldsRes.paymentMethod;
                }
              }
            } else {
              if (!fieldsRes.paymentMethod && this.transferMethodList && this.transferMethodList.length) {
                this.selectedMethod = this.transferMethodList[0];
              } else {
                this.selectedMethod = fieldsRes.paymentMethod;
              }
            }
          } else {
            ShowErrorMessage(this.$t('message.transfer.noTransferFieldsTips'));
          }
        }
      } catch (err) {
        // 出错时恢复原来的列表
        if (currentMethodList.length > 0) {
          this.transferMethodList = currentMethodList;
        }
        //
      } finally {
        console.log(payeeFields, 'PAYEE_FIELDS');
        this.payeeFieldList = PAYEE_FIELDS.map((item, index) => ({
          key: item.key,
          field: payeeFields ? payeeFields[index] : '',
        }));
        this.txnFieldList = TXN_FIELDS.map((item, index) => ({
          key: item.key,
          field: txnFields ? txnFields[index] : '',
        }));

        this.dataLoading = false;
        // 释放锁
        this._isQueryingMethods = false;
      }
    },
    async handleChangeCountry(value) {
      console.log('触发了吗guan3');
      this.$refs.cashFormRef.setItemValue('pickUpBankName', '');
      this.$refs.cashFormRef.setItemValue('pickUpBankBranchName', '');
      this.$refs.cashFormRef.setValidationSelectOptions('pickUpBankName', []);
      this.$refs.cashFormRef.setValidationSelectOptions('pickUpBankBranchName', []);
      await this.fetchPayoutConfig(value);
      this.$refs.contactFormRef.setItemValue('payoutCurrency', '');
      let accountTypeOptions = ACCOUNT_TYPE_OPTIONS;
      if (value !== 'JP') {
        accountTypeOptions = ACCOUNT_TYPE_OPTIONS.filter(item => item.value !== 'ordinary');
      }
      this.$refs.bankFormRef.setValidationSelectOptions('accountType', shallowClones(accountTypeOptions));
      this.$refs.swiftFormRef.setValidationSelectOptions('accountType', shallowClones(accountTypeOptions));
      // 切换国家清空关联数据
      this.$refs.contactFormRef.setItemValue('state', '');
      this.$refs.contactFormRef.setItemValue('city', '');
      this.$refs.contactFormRef.setValidationSelectOptions('state', []);
      this.$refs.contactFormRef.setValidationSelectOptions('city', []);
      this.countryInfo = [];
      await this.fetchCountryInfo();
      this.transferMethodList = [];
      this.onChangeValue();
    },
    async fetchCountryInfo() {
      try {
        const bankCountry = this.formData.bankCountry;
        if (bankCountry) {
          this.countryInfo = await queryCountryCity({ countryCodeIso2: bankCountry });
        }
      } catch (err) {
        //
      }
    },
    onChangeValue() {
      const form = this.$refs.contactFormRef;
      const data = this.$refs.contactFormRef.getFormJson();

      const bankForm = this.$refs.bankFormRef;
      const swiftForm = this.$refs.swiftFormRef;
      const walletForm = this.$refs.walletFormRef;
      const cashForm = this.$refs.cashFormRef;

      const { bankCountry } = this.formData;
      const {
        entityType,
        state,
      } = data;

      let showState = false;
      let showCity = false;
      for (let i = 0; i < this.payeeFieldList.length; i++) {
        const key = this.payeeFieldList[i].key;
        const field = this.payeeFieldList[i].field;
        let isHide = true;
        let required = true;
        if (field === 'Y') { // 必填
          isHide = false;
          required = true;
        } else if (field === 'C') { // 选填
          isHide = false;
          required = false;
        }
        form.setItemHide(key, isHide);
        form.setItemRequire(key, required);

        if (key === 'address1') {
          form.setItemHide('address2', isHide);
          form.setItemHide('address3', isHide);
        }

        if (key === 'phone') {
          form.getValidationItem('phone').prepend = COUNTRY_PHONE_CODE_MAP[bankCountry];
        }

        if (key === 'state') {
          showState = !isHide;
        } else if (key === 'city') {
          showCity = !isHide;
        }
      }

      let showPickUpBankBranchName = false;
      let showCardNumber = false;
      for (let i = 0; i < this.txnFieldList.length; i++) {
        const key = this.txnFieldList[i].key;
        const field = this.txnFieldList[i].field;
        if (['swiftCode', 'accountType', 'bankHolderName', 'cardNumber', 'sortCode', 'branchCode', 'iban'].includes(key)) { // 银行账户
          if (key === 'cardNumber') {
            showCardNumber = field !== 'N';
            bankForm.setItemName('cardNumber', this.$t('message.contact.accountNumber'));
            bankForm.setItemHide('cardNumber', field === 'N');

            swiftForm.setItemName('cardNumber', this.$t('message.contact.accountNumber'));
            swiftForm.setItemHide('cardNumber', field === 'N');
          } else if (key === 'iban') { // 字段映射
            if (!showCardNumber) {
              bankForm.setItemName('cardNumber', 'IBAN');
              bankForm.setItemHide('cardNumber', field === 'N');

              swiftForm.setItemName('cardNumber', 'IBAN');
              swiftForm.setItemHide('cardNumber', field === 'N');
            }
          } else {
            bankForm.setItemHide(key, field === 'N');

            swiftForm.setItemHide(key, field === 'N');
          }
        } else if (['walletType', 'walletPhone'].includes(key)) { // 钱包
          walletForm.setItemHide(key, field === 'N');
        } else if (['pickUpBankBranchName', 'pickUpBankAddress'].includes(key)) { // 现金支取
          if (key === 'pickUpBankBranchName') {
            showPickUpBankBranchName = field !== 'N';
            cashForm.setItemHide('pickUpBankBranchName', field === 'N');
            cashForm.setItemHide('pickUpBankName', field === 'N');
          } else if (key === 'pickUpBankAddress' && !showPickUpBankBranchName) {
            cashForm.setItemHide('pickUpBankBranchName', field === 'N');
            cashForm.setItemHide('pickUpBankName', field === 'N');
          }
        }
      }

      const walletFormData = walletForm.getFormJson();
      if (walletFormData.walletType) {
        const walletTypeInfo = this.walletTypeList.filter(item => item.walletType === walletFormData.walletType)[0];
        walletForm.getValidationItem('walletPhone').prepend = (walletTypeInfo && walletTypeInfo.textType !== 'TEXT' && bankCountry) ? COUNTRY_PHONE_CODE_MAP[bankCountry] : '';
      }

      // vatNumber: 当"收款行国家/地区"为Brazil时必填
      if (['BR'].includes(bankCountry)) {
        if (`${entityType}` === '1') { // 个人
          form.getValidationItem('vatNumber').maxLength = 11;
          form.setItemName('vatNumber', 'CPF');
        } else if (`${entityType}` === '0') {
          form.getValidationItem('vatNumber').maxLength = 14;
          form.setItemName('vatNumber', 'CNPJ');
        }
      } else if (['CN'].includes(bankCountry)) {
        if (`${entityType}` === '1') { // 个人
          form.getValidationItem('vatNumber').maxLength = 18;
          form.setItemName('vatNumber', this.$t('message.contact.identificationNumber'));
        } else if (`${entityType}` === '0') {
          form.getValidationItem('vatNumber').maxLength = 18;
          form.setItemName('vatNumber', this.$t('message.contact.organizationCode'));
        }
      }

      if (showState) {
        const stateObj = [];
        const stateList = [];
        const cityList = [];
        for (let i = 0; i < this.countryInfo.length; i++) {
          const item = this.countryInfo[i];
          if (item.stateCode && !stateObj[item.stateCode]) {
            stateObj[item.stateCode] = item;
            stateList.push({
              value: `${item.stateCode}`,
              label: `${item.stateNameCn}-${item.stateName}`,
            });
          }
          if (state && state === item.stateCode) {
            cityList.push({
              value: `${item.cityName}`,
              label: `${item.cityNameCn}-${item.cityName}`,
            });
          }
        }
        form.setValidationSelectOptions('state', stateList);
        form.setValidationSelectOptions('city', cityList);
      } else if (showCity) {
        form.setValidationSelectOptions('city', this.countryInfo.map(item => ({
          value: `${item.cityName}`,
          label: `${item.cityNameCn}-${item.cityName}`,
        })));
      }

      if (['JP'].includes(bankCountry)) {
        form.getValidationItem('firstName').tipList = [{
          value: this.$t('message.contact.jpNameTips'),
        }];
        form.getValidationItem('lastName').tipList = [{
          value: this.$t('message.contact.jpNameTips'),
        }];
      } else {
        form.getValidationItem('firstName').tipList = [];
        form.getValidationItem('lastName').tipList = [];
      }
    },

    async fetchPayoutConfig(country) {
      this.dataLoading = true;
      try {
        // 获取币种
        const res = await queryPayoutExchangeConfig({ country });
        const currencyList = [];
        // 去重
        res.forEach(item => {
          if (currencyList.indexOf(item.payoutCurrency) === -1) {
            currencyList.push(item.payoutCurrency);
          }
        });
        this.$refs.contactFormRef.setValidationSelectOptions('payoutCurrency', currencyList.map(item => ({
          label: item,
          value: item,
        })));

        try {
          this.walletTypeList = [];
          const res1 = await queryWalletTypeByCountry({ country });
          this.walletTypeList = res1;
          this.$refs.walletFormRef.setValidationSelectOptions('walletType', res1.map(item => ({
            label: item.viewName || item.walletType,
            value: item.walletType,
          })));
        } catch (err) {
        }

        try {
          this.bankBranchInfoList = [];
          const res2 = await queryPickUpBankNameByCountry({ country });
          const pickUpBankNameList = res2.map(item => ({
            label: item,
            value: item,
          }));
          this.$refs.cashFormRef.setValidationSelectOptions('pickUpBankName', pickUpBankNameList);
          const curPickUpBankName = this.$refs.cashFormRef.getItemValue('pickUpBankName');
          let pickUpBankName = '';
          for (let i = 0; i < pickUpBankNameList.length; i++) {
            if (pickUpBankNameList[i].value === curPickUpBankName) {
              pickUpBankName = curPickUpBankName;
              break;
            }
          }
          if (pickUpBankName) {
            // 获取分行机构
            const res3 = await queryPickUpBankBranchInfo({ institutionName: pickUpBankName });
            this.bankBranchInfoList = res3;
            const bankBranchList = [{
              value: 'title',
              label: this.$t('message.contact.bankBranchName'),
              disabled: true,
              type: 'title',
            }];
            const bankBranchMap = {};
            res3.forEach(item => {
              const branchName = item.branchName;
              const branchAddress = item.branchAddress;
              if (!bankBranchMap[branchName]) {
                bankBranchMap[branchName] = {
                  value: branchName,
                  label: branchName,
                  children: [],
                };
              }
              if (branchAddress) {
                bankBranchMap[branchName].children.push({
                  value: branchAddress,
                  label: branchAddress,
                });
              }
            });

            Object.keys(bankBranchMap).forEach(k => {
              const item = bankBranchMap[k];
              const obj = {
                value: item.value,
                label: item.label,
              };
              if (item.children && item.children.length > 0) {
                obj.children = item.children;
                obj.children.unshift({
                  value: 'subtitle',
                  label: this.$t('message.contact.bankBranchAddress'),
                  disabled: true,
                  type: 'title',
                });
              }
              bankBranchList.push(obj);
            });
            this.$refs.cashFormRef.setValidationSelectOptions('pickUpBankBranchName', bankBranchList);
          } else {
            this.$refs.cashFormRef.setItemValue('pickUpBankName', '');
            this.$refs.cashFormRef.setItemValue('pickUpBankBranchName', '');
          }
        } catch (err) {
          console.log(err);
        }
      } catch (err) {

      }
      this.dataLoading = false;
    },
    onClose() {
      this.$router.go(-1);
    },
    checkFieldHasChanged() {
      console.log('触发了吗guan');
      if (!this.oldInfo) {
        return;
      }
      // 在使用transferMethodList前先保存其值
      const currentMethodList = [...this.transferMethodList];
      // 如果当前列表为空但之前保存过有效值，恢复它
      if (currentMethodList.length === 0 && this.lastValidMethodList && this.lastValidMethodList.length > 0) {
        this.transferMethodList = [...this.lastValidMethodList];
      } else if (currentMethodList.length > 0) {
        // 保存当前有效值
        this.lastValidMethodList = [...currentMethodList];
      }
      const contactInfo = this.$refs.contactFormRef.getFormJson();
      const bankData = this.transferMethodList.includes('BANK_TRANSFER') ? this.$refs.bankFormRef.getFormJson() : {};
      const swiftData = this.transferMethodList.includes('SWIFT') ? this.$refs.swiftFormRef.getFormJson() : {};
      const walletData = this.$refs.walletFormRef.getFormJson();
      const cashData = this.$refs.cashFormRef.getFormJson();

      const params = {
        ...this.formData,
        ...contactInfo,
        ...bankData,
        ...swiftData,
        ...walletData,
        ...cashData,
      };

      const newData = this.getSubmitData(params);
      const keys = Object.keys(newData);
      let hasChanged = false;
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i];
        if (newData[k] && (newData[k] !== this.oldInfo[k])) {
          hasChanged = true;
          break;
        }
      }
      this.btnDisabled = !hasChanged;
      // 确保方法执行完后transferMethodList仍然有效
      if (this.transferMethodList.length === 0 && this._lastValidMethodList && this._lastValidMethodList.length > 0) {
        this.transferMethodList = [...this._lastValidMethodList];
      }
    },
    getSubmitData(params) {
      const data = {};
      // 共有字段
      const commonKeys = [
        'accountBelong', 'entityType', 'payoutCurrency', 'bankCountry',
        'payeeAddress', 'bankAccount',
      ];
      if (this.contactId) {
        data.cardInfoId = this.contactId;
      }
      let paymentMethod = '';
      // TODO:新增参数paymentMethod 当前选中的支付方式，编辑的时候默认回显
      if (this.selectedMethod) {
        paymentMethod = this.transferMethodListOptions.find(item => item.value === this.selectedMethod)?.code;
        data.paymentMethod = paymentMethod;
      }
      commonKeys.forEach(k => {
        data[k] = params[k];
      });

      if (!data.payoutCurrency) {
        const payoutCurrencyFormIten = this.selectedMethod === 'BANK_TRANSFER' ? this.$refs.bankFormRef.getValidationItem('payoutCurrency') : {};
        if (payoutCurrencyFormIten) {
          const list = payoutCurrencyFormIten.options;
          if (list && list.length > 0) {
            data.payoutCurrency = list[0].value;
            params.payoutCurrency = list[0].value;
          }
        }

        const swiftPayoutCurrencyFormIten = this.selectedMethod === 'SWIFT' ? this.$refs.swiftFormRef.getValidationItem('payoutCurrency') : {};
        if (swiftPayoutCurrencyFormIten) {
          const list = swiftPayoutCurrencyFormIten.options;
          if (list && list.length > 0) {
            data.payoutCurrency = list[0].value;
            params.payoutCurrency = list[0].value;
          }
        }
      }

      const { bankCountry, entityType } = params;
      data.payeeCountry = bankCountry; // 收款方国家取值付款至国家
      data.areaCode = COUNTRY_PHONE_CODE_MAP[bankCountry];

      for (let i = 0; i < this.payeeFieldList.length; i++) {
        const key = this.payeeFieldList[i].key;
        const field = this.payeeFieldList[i].field;
        if (field === 'N') {
          continue;
        }
        if (key === 'address1') {
          data.address1 = params.address1;
          data.address2 = params.address2;
          data.address3 = params.address3;
        } else {
          data[key] = params[key];
        }
      }

      for (let i = 0; i < this.txnFieldList.length; i++) {
        const key = this.txnFieldList[i].key;
        const field = this.txnFieldList[i].field;
        if (field === 'N') {
          continue;
        }
        if (['swiftCode', 'accountType', 'bankHolderName', 'cardNumber', 'sortCode', 'branchCode', 'iban'].includes(key)) { // 银行账户
          if (key === 'iban') { // 字段映射
            data.cardNumber = params.cardNumber;
          } else {
            data[key] = params[key];
          }
        } else if (['walletType', 'walletPhone'].includes(key)) { // 钱包
          data[key] = params[key];
        } else if (['pickUpBankBranchName', 'pickUpBankAddress'].includes(key)) { // 现金支取
          data.pickUpBankBranchName = params.pickUpBankBranchName;
          data.pickUpBankName = params.pickUpBankName;
        }
      }

      for (let i = 0; i < this.swiftCodeList.length; i++) {
        const item = this.swiftCodeList[i];
        if (data.swiftCode === item.value) {
          data.bankName = item.bankName;
          break;
        }
      }

      if (data.pickUpBankBranchName) {
        const branchInfo = data.pickUpBankBranchName.split('***');
        for (let i = 0; i < this.bankBranchInfoList.length; i++) {
          const bankBranch = this.bankBranchInfoList[i];
          if (bankBranch.branchName === branchInfo[0]) {
            data.pickUpBankBranchName = bankBranch.branchName;
            if (branchInfo[1] && bankBranch.branchAddress === branchInfo[1]) {
              data.pickUpBankBranchId = bankBranch.branchId;
              break;
            } else if (!branchInfo[1]) {
              data.pickUpBankBranchId = bankBranch.branchId;
              break;
            }
          }
        }
      }

      if (data.payee) {
        data.payee = data.payee.trim();
      }
      if (data.entityType === '1') {
        data.bankAccount = data.lastName ? (data.firstName + ' ' + data.lastName) : data.firstName;
      } else {
        data.bankAccount = data.companyName;
      }

      return data;
    },
    onSubmit() {
      this.$refs.contactFormRef.toFormValid(async (contactInfo) => {
        if (this.transferMethodList.length === 0) {
          ShowErrorMessage(this.$t('message.transfer.noTransferMethodTips'));
          return;
        }
        if (this.transferMethodList.includes('BANK_TRANSFER') && this.selectedMethod === 'BANK_TRANSFER') {
          const bankFormValid = await this.$refs.bankFormRef.validateAsync();
          if (!bankFormValid) {
            this.showBankInfo = true;
            return;
          }
        }
        if (this.transferMethodList.includes('SWIFT') && this.selectedMethod === 'SWIFT') {
          const swiftFormValid = await this.$refs.swiftFormRef.validateAsync();
          if (!swiftFormValid) {
            this.showSwiftInfo = true;
            return;
          }
        }
        if (this.transferMethodList.includes('E_WALLET') && this.selectedMethod === 'E_WALLET') {
          const EwalletFormValid = await this.$refs.walletFormRef.validateAsync();
          if (!EwalletFormValid) {
            this.showWalletInfo = true;
            return;
          }
        }
        if (this.transferMethodList.includes('CASH_PICKUP') && this.selectedMethod === 'CASH_PICKUP') {
          const cashFormValid = await this.$refs.cashFormRef.validateAsync();
          if (!cashFormValid) {
            this.showSwiftInfo = true;
            return;
          }
        }

        const bankData = this.transferMethodList.includes('BANK_TRANSFER') ? this.$refs.bankFormRef.getFormJson() : {};
        const swiftData = this.transferMethodList.includes('SWIFT') ? this.$refs.swiftFormRef.getFormJson() : {};
        const walletData = this.$refs.walletFormRef.getFormJson();
        const cashData = this.$refs.cashFormRef.getFormJson();
        const params = {
          ...this.formData,
          ...contactInfo,
          ...bankData,
          ...swiftData,
          ...walletData,
          ...cashData,
        };
        const data = this.getSubmitData(params);
        data.businessType = this.businessType ? (this.businessType === 'payout' ? 'PAYOUT' : 'ACQUIRING') : null;
        console.log(data, '2222222222');
        let MethodSub = postAddPayeeVerify;
        if (this.contactId) {
          MethodSub = postUpdatePayeeVerify; // 修改
        }
        // TODO 移除不保存的场景
        // else if (this.fromTransfer && !this.isSaveContact) { // 从付款页过来且选择不保存时，
        //   // MethodSub = postValidatePayee;
        // }
        this.dataLoading = true;
        try {
          const res = await MethodSub(data);
          this.dataLoading = false;
          if (this.fromTransfer) { // 如果是从付款页跳过来的则跳回付款页
            const transferData = {
              contactInfo: data,
            };
            window.sessionStorage.setItem('transferData', JSON.stringify(transferData));
            this.$router.replace({
              path: '/transfer/transfer/add/amount',
              query: { id: res, currency: this.$route.query.currency, businessType: this.businessType },
            });
            return;
          }
          ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
          this.$router.go(-1);
        } catch (err) {
          //
        }
        this.dataLoading = false;
      });
    },
    isFieldRequired(key) {
      let required = false;
      for (let i = 0; i < this.payeeFieldList.length; i++) {
        if (this.payeeFieldList[i].key === key) {
          required = this.payeeFieldList[i].field === 'Y';
          break;
        }
      }
      return required;
    },
    validateCompanyName(rule, value, callback) {
      if (this.isFieldRequired('companyName') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      if (value) {
        if (!ENGLISH_NAME.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputEnglish')));
          return;
        }
        if (value.length >= 30) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '[0, 30)' })));
          return;
        }
      }
      callback();
    },
    validateAddress1(rule, value, callback) {
      if (this.isFieldRequired('address1') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      if (value) {
        // if (!ENGLISH_NAME.regExp.test(value)) {
        //   callback(new Error(this.$t('message.validator.inputEnglish')));
        //   return;
        // }
        if (value.length < 5 || value.length >= 200) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '[5, 200)' })));
          return;
        }
      }
      callback();
    },
    validateAddress2(rule, value, callback) {
      if (value) {
        // if (!ENGLISH_NAME.regExp.test(value)) {
        //   callback(new Error(this.$t('message.validator.inputEnglish')));
        //   return;
        // }
        if (value.length < 5 || value.length >= 200) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '[5, 200)' })));
          return;
        }
      }
      callback();
    },
    validateAddress3(rule, value, callback) {
      if (value) {
        // if (!ENGLISH_NAME.regExp.test(value)) {
        //   callback(new Error(this.$t('message.validator.inputEnglish')));
        //   return;
        // }
        if (value.length < 5 || value.length >= 200) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '[5, 200)' })));
          return;
        }
      }
      callback();
    },
    validatePayee(rule, value, callback) {
      if (this.isFieldRequired('payee') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      callback();
    },
    validateFirstName(rule, value, callback) {
      if (this.isFieldRequired('firstName') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      callback();
    },
    validateLastName(rule, value, callback) {
      if (this.isFieldRequired('lastName') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      callback();
    },
    validateBirthDate(rule, value, callback) {
      if (this.isFieldRequired('birthDate') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      callback();
    },
    validateEmail(rule, value, callback) {
      if (this.isFieldRequired('email') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      callback();
    },
    validateState(rule, value, callback) {
      if (this.isFieldRequired('state') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      callback();
    },
    validateCity(rule, value, callback) {
      if (this.isFieldRequired('city') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      callback();
    },
    validatePhone(rule, value, callback) {
      const data = this.$refs.contactFormRef.getFormJson();
      const { payoutCurrency } = data;
      const { bankCountry } = this.formData;
      if (this.isFieldRequired('phone') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      if (payoutCurrency === 'CNY' && bankCountry === 'CN' && !PHONE_NUMBER.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.inputPhone')));
        return;
      }
      callback();
    },
    validateWalletPhone(rule, value, callback) {
      const data = this.$refs.contactFormRef.getFormJson();
      const { payoutCurrency } = data;
      const { bankCountry } = this.formData;
      if (!value) { // 选填
        callback();
        return;
      }
      // if (payoutCurrency === 'CNY' && bankCountry === 'CN' && !PHONE_NUMBER.regExp.test(value)) {
      //   callback(new Error(this.$t('message.validator.inputPhone')));
      //   return;
      // }
      callback();
    },
    validateZipCode(rule, value, callback) {
      if (this.isFieldRequired('zipCode') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      if (value) {
        if (value.length < 4 || value.length >= 8) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '[4, 8)' })));
          return;
        }
      }
      callback();
    },
    validateVatNumber(rule, value, callback) {
      const data = this.$refs.contactFormRef.getFormJson();
      const { entityType } = data;
      const { bankCountry } = this.formData;
      if (this.isFieldRequired('vatNumber') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      if (value) {
        if (bankCountry === 'BR') {
          if (!AllNumber.regExp.test(value)) {
            callback(new Error(this.$t('message.validator.inputNumber')));
            return;
          }
          if (`${entityType}` === '1' && value.length !== 11) {
            callback(new Error(this.$t('message.validator.inputLength', { length: '11' })));
            return;
          }
          if (`${entityType}` === '0' && value.length !== 14) {
            callback(new Error(this.$t('message.validator.inputLength', { length: '14' })));
            return;
          }
        } else if (bankCountry === 'CN') {
          if (`${entityType}` === '1' &&
            !(/^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value) ||
              /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/.test(value))) { // 个人
            callback(new Error(this.$t('message.validator.formatError', { field: this.$t('message.contact.identificationNumber').toLowerCase() })));
            return;
          }
          if (`${entityType}` === '0' && value.length > 18) {
            callback(new Error(this.$t('message.validator.maxInputLength', { length: '18' })));
            return;
          }
        }
      }
      callback();
    },
    validateAccountType(rule, value, callback) {
      const { bankCountry } = this.formData;
      if (!value && (bankCountry === 'US' || bankCountry === 'BR')) {
        callback(new Error(this.$t('message.validator.required')));
        return;
      }
      callback();
    },
    validateBankHolderName(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      if (!EN_NUMBER_SPACE.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.enNumberSpace')));
        return;
      }
      callback();
    },
    validateSortCode(rule, value, callback) {
      const { bankCountry } = this.formData;
      // if (!value || REQUIRED.regExp.test(value)) {
      //   callback(new Error(this.$t('message.validator.required')));
      //   return;
      // }
      if (!value) {
        callback();
        return;
      }
      // Indonesia：Numeric (3)
      // Philippines：Numeric (9)
      // United States：Numeric (9)，对应ABA Routing Number
      // Canada：String (3)
      // brazil：Numeric (3)
      // South Korea：Numeric (3)
      // United Kingdom：Numeric (6)，对应Sort Code
      // 日本-Japan，Numeric (4)
      if (bankCountry === 'ID') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return;
        }
        if (value.length !== 3) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '3' })));
          return;
        }
      }
      if (bankCountry === 'PH') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return;
        }
        if (value.length !== 9) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '9' })));
          return;
        }
      }
      if (bankCountry === 'US') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return;
        }
        if (value.length !== 9) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '9' })));
          return;
        }
      }
      if (bankCountry === 'CA' && value.length !== 3) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '3' })));
        return;
      }
      if (bankCountry === 'BR') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return;
        }
        if (value.length !== 3) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '3' })));
          return;
        }
      }
      if (bankCountry === 'KR') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return;
        }
        if (value.length !== 3) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '3' })));
          return;
        }
      }
      if (bankCountry === 'GB') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return;
        }
        if (value.length !== 6) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '6' })));
          return;
        }
      }
      if (bankCountry === 'JP') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return;
        }
        if (value.length !== 4) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '4' })));
          return;
        }
      }
      callback();
    },
    validateBranchCode(rule, value, callback) {
      const { bankCountry } = this.formData;
      // if (!value || REQUIRED.regExp.test(value)) {
      //   callback(new Error(this.$t('message.validator.required')));
      //   return;
      // }
      if (!value) {
        callback();
        return;
      }
      // Brazil：String (1-4)
      // Canada：String (5)
      // Indonesia：Numeric (4)
      // Japan：Numeric (3)
      // Vietnam: Number[1-5]
      if (bankCountry === 'BR' && value.length > 4) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[1-4]' })));
        return;
      }
      if (bankCountry === 'CA' && value.length !== 5) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '5' })));
        return;
      }
      if (bankCountry === 'ID') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return;
        }
        if (value.length !== 4) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '4' })));
          return;
        }
      }
      if (bankCountry === 'JP') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return;
        }
        if (value.length !== 3) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '3' })));
          return;
        }
      }
      if (bankCountry === 'VN') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return;
        }
        if (value.length > 5) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '[1, 5]' })));
          return;
        }
      }
      callback();
    },
    handlePayoutMethod(index) {
      if (index === this.payoutMethod) {
        return;
      }
      this.selectedMethod = index;
    },

  },
  watch: {
    selectedMethod: {
      handler(value) {
        this.selectedMethodChange(value);
      },
      immediate: true,
    },
    transferMethodList: {
      handler(value) {
        console.log(value, 'guanvalue');
      },
      immediate: true,
    },

  },
};
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';

.contact-form {
  width: 450px;
  margin: 20px auto 0;

  ::v-deep .rhch-upload-container {
    width: 450px;
    min-width: auto;

    .el-upload-dragger,
    .rhch-file-list {
      width: 450px;
      min-width: auto;
    }

    .rhch-file-list .rhch-file-item .rhcn-filename {
      max-width: 240px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  ::v-deep .el-form-item__label {
    color: $color-text-primary;
    line-height: 32px;
    padding-bottom: 0px;
    font-weight: 800;
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  .contact-title-box {
    position: relative;
    height: 44px;
    border-radius: 2px;
    border: 2px solid #9CBAEC;
    font-size: 14px;
    font-family: PingFang-SC, PingFang-SC;
    font-weight: bold;
    color: #1C4377;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .icon-caret {
      position: absolute;
      right: 10px;
      font-size: 20px;
    }

    &.open {
      .icon-caret {
        transform: rotateX(-180deg);
      }
    }
  }

  .btn-save-contact {
    font-size: 14px;
    font-weight: bold;
    color: $color-text-primary;
    line-height: 32px;
  }

  .bottom-box {
    display: flex;
    flex-direction: column;
    align-items: center;

    .btn-previous {
      cursor: pointer;
      color: $color-text-default-button;
      font-weight: 600;
    }
  }
}

.methodType {
  .payout-method-title {
    font-size: 14px;
    color: $color-text-primary;
    line-height: 20px;
    font-weight: bold;
  }

  .payout-method-list {
    display: flex;
    align-items: center;

    .payout-method-item {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 44px;
      border: 2px solid #D3DADD;
      border-left: none;
      font-size: 14px;
      color: $color-text-primary;
      line-height: 20px;
      font-weight: bold;
      cursor: pointer;

      &:first-child {
        border-left: 2px solid #D3DADD;
        border-radius: 2px 0px 0px 2px;
        box-shadow: none !important;
      }

      &:last-child {
        border-radius: 0px 2px 2px 0px;
      }

      &.checked {
        border-color: $color-primary;
        box-shadow: -2px 0 0 0 $color-primary;
      }
    }
  }
}
</style>
<style lang="scss">
.rhcn-cascader-dropdown {
  .el-cascader-panel {
    min-width: 450px;

    .el-cascader-menu__list .el-cascader-node .el-cascader-node-content.label {
      max-width: 450px;
    }
  }
}
</style>
